[
	{
		"artsuch": "Stecker",
		"betaufnr": 127001,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127001",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.44,
		"Date_of_arrival": "2021-08-01T15:00:00",
		"Date_of_Extraction": "2021-08-01T15:00:00",
		"Date_of_Analysis": "2021-08-01T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.560025,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 12923.0,
		"woF_15_25": 6172.0,
		"woF_25_50": 2840.0,
		"woF_50_100": 1037.0,
		"woF_100_150": 173.0,
		"woF_150_200": 62.0,
		"woF_200_400": 41.0,
		"woF_400_600": 4.0,
		"woF_600_1000": 3.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 235.0,
		"woF_300_400": 45.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 2.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 12923.0,
		"All_15_25": 6172.0,
		"All_25_50": 2840.0,
		"All_50_100": 1037.0,
		"All_100_150": 175.0,
		"All_150_200": 62.0,
		"All_200_400": 51.0,
		"All_400_600": 17.0,
		"All_600_1000": 11.0,
		"All_gt_1000": 3.0,
		"All_200_300": 237.0,
		"All_300_400": 68.0,
		"All_400_500": 3.0,
		"All_500_600": null,
		"All_600_700": 3.0,
		"All_700_800": 3.0,
		"All_800_900": 3.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 21.0,
		"Met_15_25": 40.0,
		"Met_25_50": 46.0,
		"Met_50_100": 51.0,
		"Met_100_150": 18.0,
		"Met_150_200": 14.0,
		"Met_200_400": 7.0,
		"Met_400_600": 3.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 32.0,
		"Met_300_400": 10.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 839.0,
		"woFNM_1W": 283.0,
		"woFNM_2L": 750.0,
		"woFNM_2W": 308.0,
		"woFNM_3L": 711.0,
		"woFNM_3W": 298.0,
		"woFNM_4L": 403.0,
		"woFNM_4W": 118.0,
		"woFNM_5L": 397.0,
		"woFNM_5W": 238.0,
		"Met_1L": 527.0,
		"Met_1W": 97.0,
		"Met_2L": 523.0,
		"Met_2W": 97.0,
		"Met_3L": 489.0,
		"Met_3W": 259.0,
		"Met_4L": 291.0,
		"Met_4W": 93.0,
		"Met_5L": 285.0,
		"Met_5W": 167.0,
		"Fib_Fmax1_Fmax": 2208.0,
		"Fib_Fmax1_Lstr": 2420.0,
		"Fib_Fmax2_Fmax": 1647.0,
		"Fib_Fmax2_Lstr": 3010.0,
		"Fib_Lstr1_Fmax": 912.0,
		"Fib_Lstr1_Lstr": 3933.0,
		"Fib_Fmax_Sum_um": 21080.0,
		"Fib_Stretched_Sum_um": 29580.0,
		"woF_weighted_sum": 3631.0,
		"All_weighted_sum": 6983.0,
		"Met_weighted_sum": 553.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127001,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 93.0,
		"nm_sum": 1227.0,
		"sum_fibers": 35.0,
		"fibers_sum": 35.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127002,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127002",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.36,
		"Date_of_arrival": "2021-08-02T15:00:00",
		"Date_of_Extraction": "2021-08-02T15:00:00",
		"Date_of_Analysis": "2021-08-02T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.425026,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 12658.0,
		"woF_15_25": 6429.0,
		"woF_25_50": 2603.0,
		"woF_50_100": 774.0,
		"woF_100_150": 105.0,
		"woF_150_200": 35.0,
		"woF_200_400": 7.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 140.0,
		"woF_300_400": 8.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 12658.0,
		"All_15_25": 6429.0,
		"All_25_50": 2603.0,
		"All_50_100": 774.0,
		"All_100_150": 105.0,
		"All_150_200": 35.0,
		"All_200_400": 24.0,
		"All_400_600": 6.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 0.0,
		"All_200_300": 140.0,
		"All_300_400": 30.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 4.0,
		"Met_15_25": 32.0,
		"Met_25_50": 38.0,
		"Met_50_100": 34.0,
		"Met_100_150": 11.0,
		"Met_150_200": 8.0,
		"Met_200_400": 2.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 19.0,
		"Met_300_400": 2.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 481.0,
		"woFNM_1W": 97.0,
		"woFNM_2L": 340.0,
		"woFNM_2W": 49.0,
		"woFNM_3L": 315.0,
		"woFNM_3W": 76.0,
		"woFNM_4L": 260.0,
		"woFNM_4W": 130.0,
		"woFNM_5L": 247.0,
		"woFNM_5W": 147.0,
		"Met_1L": 248.0,
		"Met_1W": 85.0,
		"Met_2L": 223.0,
		"Met_2W": 22.0,
		"Met_3L": 198.0,
		"Met_3W": 27.0,
		"Met_4L": 185.0,
		"Met_4W": 59.0,
		"Met_5L": 184.0,
		"Met_5W": 16.0,
		"Fib_Fmax1_Fmax": 740.0,
		"Fib_Fmax1_Lstr": 920.0,
		"Fib_Fmax2_Fmax": 560.0,
		"Fib_Fmax2_Lstr": 647.0,
		"Fib_Lstr1_Fmax": 740.0,
		"Fib_Lstr1_Lstr": 920.0,
		"Fib_Fmax_Sum_um": 8004.0,
		"Fib_Stretched_Sum_um": 8994.0,
		"woF_weighted_sum": 1685.0,
		"All_weighted_sum": 2421.0,
		"Met_weighted_sum": 182.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127002,
		"Passed": "1",
		"zeichnr": "Stecker",
		"met_sum": 55.0,
		"nm_sum": 867.0,
		"sum_fibers": 23.0,
		"fibers_sum": 23.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127003,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127003",
		"Parts_on_Filter": 6.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.56,
		"Date_of_arrival": "2021-08-03T15:00:00",
		"Date_of_Extraction": "2021-08-03T15:00:00",
		"Date_of_Analysis": "2021-08-03T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.602711,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 16367.0,
		"woF_15_25": 8205.0,
		"woF_25_50": 3925.0,
		"woF_50_100": 1201.0,
		"woF_100_150": 191.0,
		"woF_150_200": 63.0,
		"woF_200_400": 22.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 254.0,
		"woF_300_400": 22.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 16367.0,
		"All_15_25": 8205.0,
		"All_25_50": 3925.0,
		"All_50_100": 1201.0,
		"All_100_150": 194.0,
		"All_150_200": 64.0,
		"All_200_400": 45.0,
		"All_400_600": 8.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 1.0,
		"All_200_300": 258.0,
		"All_300_400": 53.0,
		"All_400_500": 1.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 12.0,
		"Met_15_25": 39.0,
		"Met_25_50": 67.0,
		"Met_50_100": 37.0,
		"Met_100_150": 12.0,
		"Met_150_200": 4.0,
		"Met_200_400": 2.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 16.0,
		"Met_300_400": 2.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 680.0,
		"woFNM_1W": 133.0,
		"woFNM_2L": 399.0,
		"woFNM_2W": 54.0,
		"woFNM_3L": 284.0,
		"woFNM_3W": 76.0,
		"woFNM_4L": 277.0,
		"woFNM_4W": 119.0,
		"woFNM_5L": 267.0,
		"woFNM_5W": 19.0,
		"Met_1L": 291.0,
		"Met_1W": 68.0,
		"Met_2L": 224.0,
		"Met_2W": 92.0,
		"Met_3L": 194.0,
		"Met_3W": 65.0,
		"Met_4L": 176.0,
		"Met_4W": 81.0,
		"Met_5L": 159.0,
		"Met_5W": 119.0,
		"Fib_Fmax1_Fmax": 1047.0,
		"Fib_Fmax1_Lstr": 1092.0,
		"Fib_Fmax2_Fmax": 790.0,
		"Fib_Fmax2_Lstr": 1032.0,
		"Fib_Lstr1_Fmax": 639.0,
		"Fib_Lstr1_Lstr": 1120.0,
		"Fib_Fmax_Sum_um": 14496.0,
		"Fib_Stretched_Sum_um": 17982.0,
		"woF_weighted_sum": 3028.0,
		"All_weighted_sum": 4761.0,
		"Met_weighted_sum": 153.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127003,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 55.0,
		"nm_sum": 1423.0,
		"sum_fibers": 39.0,
		"fibers_sum": 39.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127004,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127004",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.21,
		"Date_of_arrival": "2021-08-04T15:00:00",
		"Date_of_Extraction": "2021-08-04T15:00:00",
		"Date_of_Analysis": "2021-08-04T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.156856,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 4332.0,
		"woF_15_25": 2015.0,
		"woF_25_50": 1009.0,
		"woF_50_100": 301.0,
		"woF_100_150": 51.0,
		"woF_150_200": 15.0,
		"woF_200_400": 10.0,
		"woF_400_600": 1.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 66.0,
		"woF_300_400": 11.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 4332.0,
		"All_15_25": 2015.0,
		"All_25_50": 1009.0,
		"All_50_100": 301.0,
		"All_100_150": 51.0,
		"All_150_200": 15.0,
		"All_200_400": 12.0,
		"All_400_600": 2.0,
		"All_600_1000": 0.0,
		"All_gt_1000": 0.0,
		"All_200_300": 66.0,
		"All_300_400": 14.0,
		"All_400_500": 0.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 6.0,
		"Met_15_25": 33.0,
		"Met_25_50": 31.0,
		"Met_50_100": 12.0,
		"Met_100_150": 1.0,
		"Met_150_200": 2.0,
		"Met_200_400": 2.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 3.0,
		"Met_300_400": 2.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 441.0,
		"woFNM_1W": 177.0,
		"woFNM_2L": 359.0,
		"woFNM_2W": 106.0,
		"woFNM_3L": 335.0,
		"woFNM_3W": 183.0,
		"woFNM_4L": 232.0,
		"woFNM_4W": 81.0,
		"woFNM_5L": 225.0,
		"woFNM_5W": 68.0,
		"Met_1L": 364.0,
		"Met_1W": 48.0,
		"Met_2L": 243.0,
		"Met_2W": 21.0,
		"Met_3L": 184.0,
		"Met_3W": 113.0,
		"Met_4L": 176.0,
		"Met_4W": 113.0,
		"Met_5L": 139.0,
		"Met_5W": 63.0,
		"Fib_Fmax1_Fmax": 475.0,
		"Fib_Fmax1_Lstr": 563.0,
		"Fib_Fmax2_Fmax": 297.0,
		"Fib_Fmax2_Lstr": 389.0,
		"Fib_Lstr1_Fmax": 475.0,
		"Fib_Lstr1_Lstr": 563.0,
		"Fib_Fmax_Sum_um": 995.0,
		"Fib_Stretched_Sum_um": 1239.0,
		"woF_weighted_sum": 864.0,
		"All_weighted_sum": 960.0,
		"Met_weighted_sum": 66.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127004,
		"Passed": "1",
		"zeichnr": "Stecker",
		"met_sum": 17.0,
		"nm_sum": 361.0,
		"sum_fibers": 3.0,
		"fibers_sum": 3.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127005,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127005",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.01,
		"Date_of_arrival": "2021-08-05T15:00:00",
		"Date_of_Extraction": "2021-08-05T15:00:00",
		"Date_of_Analysis": "2021-08-05T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.160574,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 3766.0,
		"woF_15_25": 1718.0,
		"woF_25_50": 899.0,
		"woF_50_100": 254.0,
		"woF_100_150": 61.0,
		"woF_150_200": 18.0,
		"woF_200_400": 7.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 79.0,
		"woF_300_400": 9.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 3766.0,
		"All_15_25": 1718.0,
		"All_25_50": 899.0,
		"All_50_100": 254.0,
		"All_100_150": 61.0,
		"All_150_200": 20.0,
		"All_200_400": 18.0,
		"All_400_600": 2.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 1.0,
		"All_200_300": 81.0,
		"All_300_400": 20.0,
		"All_400_500": 1.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 2.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 7.0,
		"Met_15_25": 21.0,
		"Met_25_50": 31.0,
		"Met_50_100": 9.0,
		"Met_100_150": 11.0,
		"Met_150_200": 3.0,
		"Met_200_400": 1.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 14.0,
		"Met_300_400": 3.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 375.0,
		"woFNM_1W": 140.0,
		"woFNM_2L": 289.0,
		"woFNM_2W": 182.0,
		"woFNM_3L": 266.0,
		"woFNM_3W": 134.0,
		"woFNM_4L": 244.0,
		"woFNM_4W": 85.0,
		"woFNM_5L": 207.0,
		"woFNM_5W": 48.0,
		"Met_1L": 567.0,
		"Met_1W": 167.0,
		"Met_2L": 417.0,
		"Met_2W": 161.0,
		"Met_3L": 251.0,
		"Met_3W": 122.0,
		"Met_4L": 185.0,
		"Met_4W": 68.0,
		"Met_5L": 161.0,
		"Met_5W": 59.0,
		"Fib_Fmax1_Fmax": 1005.0,
		"Fib_Fmax1_Lstr": 1269.0,
		"Fib_Fmax2_Fmax": 993.0,
		"Fib_Fmax2_Lstr": 1199.0,
		"Fib_Lstr1_Fmax": 1005.0,
		"Fib_Lstr1_Lstr": 1269.0,
		"Fib_Fmax_Sum_um": 8012.0,
		"Fib_Stretched_Sum_um": 9859.0,
		"woF_weighted_sum": 900.0,
		"All_weighted_sum": 2070.0,
		"Met_weighted_sum": 224.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127005,
		"Passed": "1",
		"zeichnr": "Stecker",
		"met_sum": 26.0,
		"nm_sum": 316.0,
		"sum_fibers": 18.0,
		"fibers_sum": 18.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127006,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127006",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.16,
		"Date_of_arrival": "2021-08-06T15:00:00",
		"Date_of_Extraction": "2021-08-06T15:00:00",
		"Date_of_Analysis": "2021-08-06T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.161374,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 4066.0,
		"woF_15_25": 1924.0,
		"woF_25_50": 1020.0,
		"woF_50_100": 339.0,
		"woF_100_150": 57.0,
		"woF_150_200": 16.0,
		"woF_200_400": 8.0,
		"woF_400_600": 0.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 73.0,
		"woF_300_400": 8.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 4066.0,
		"All_15_25": 1924.0,
		"All_25_50": 1020.0,
		"All_50_100": 339.0,
		"All_100_150": 57.0,
		"All_150_200": 17.0,
		"All_200_400": 13.0,
		"All_400_600": 1.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 74.0,
		"All_300_400": 14.0,
		"All_400_500": 1.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 9.0,
		"Met_15_25": 39.0,
		"Met_25_50": 36.0,
		"Met_50_100": 12.0,
		"Met_100_150": 6.0,
		"Met_150_200": 1.0,
		"Met_200_400": 3.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 7.0,
		"Met_300_400": 3.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 326.0,
		"woFNM_1W": 124.0,
		"woFNM_2L": 313.0,
		"woFNM_2W": 106.0,
		"woFNM_3L": 265.0,
		"woFNM_3W": 53.0,
		"woFNM_4L": 264.0,
		"woFNM_4W": 129.0,
		"woFNM_5L": 207.0,
		"woFNM_5W": 124.0,
		"Met_1L": 215.0,
		"Met_1W": 86.0,
		"Met_2L": 210.0,
		"Met_2W": 43.0,
		"Met_3L": 206.0,
		"Met_3W": 75.0,
		"Met_4L": 163.0,
		"Met_4W": 90.0,
		"Met_5L": 145.0,
		"Met_5W": 70.0,
		"Fib_Fmax1_Fmax": 1901.0,
		"Fib_Fmax1_Lstr": 2092.0,
		"Fib_Fmax2_Fmax": 888.0,
		"Fib_Fmax2_Lstr": 930.0,
		"Fib_Lstr1_Fmax": 1901.0,
		"Fib_Lstr1_Lstr": 2092.0,
		"Fib_Fmax_Sum_um": 5698.0,
		"Fib_Stretched_Sum_um": 6276.0,
		"woF_weighted_sum": 839.0,
		"All_weighted_sum": 1680.0,
		"Met_weighted_sum": 93.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127006,
		"Passed": "1",
		"zeichnr": "Stecker",
		"met_sum": 22.0,
		"nm_sum": 398.0,
		"sum_fibers": 10.0,
		"fibers_sum": 10.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127007,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127007",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.42,
		"Date_of_arrival": "2021-08-07T15:00:00",
		"Date_of_Extraction": "2021-08-07T15:00:00",
		"Date_of_Analysis": "2021-08-07T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.528681,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 10683.0,
		"woF_15_25": 5281.0,
		"woF_25_50": 2664.0,
		"woF_50_100": 956.0,
		"woF_100_150": 208.0,
		"woF_150_200": 74.0,
		"woF_200_400": 57.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 3.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 282.0,
		"woF_300_400": 59.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 3.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 10683.0,
		"All_15_25": 5281.0,
		"All_25_50": 2664.0,
		"All_50_100": 956.0,
		"All_100_150": 209.0,
		"All_150_200": 76.0,
		"All_200_400": 76.0,
		"All_400_600": 17.0,
		"All_600_1000": 8.0,
		"All_gt_1000": 1.0,
		"All_200_300": 285.0,
		"All_300_400": 93.0,
		"All_400_500": 1.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 5.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 10.0,
		"Met_15_25": 33.0,
		"Met_25_50": 40.0,
		"Met_50_100": 33.0,
		"Met_100_150": 11.0,
		"Met_150_200": 10.0,
		"Met_200_400": 10.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 21.0,
		"Met_300_400": 10.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 774.0,
		"woFNM_1W": 500.0,
		"woFNM_2L": 773.0,
		"woFNM_2W": 161.0,
		"woFNM_3L": 732.0,
		"woFNM_3W": 392.0,
		"woFNM_4L": 433.0,
		"woFNM_4W": 297.0,
		"woFNM_5L": 431.0,
		"woFNM_5W": 193.0,
		"Met_1L": 266.0,
		"Met_1W": 70.0,
		"Met_2L": 266.0,
		"Met_2W": 81.0,
		"Met_3L": 255.0,
		"Met_3W": 80.0,
		"Met_4L": 237.0,
		"Met_4W": 21.0,
		"Met_5L": 227.0,
		"Met_5W": 121.0,
		"Fib_Fmax1_Fmax": 1452.0,
		"Fib_Fmax1_Lstr": 2314.0,
		"Fib_Fmax2_Fmax": 943.0,
		"Fib_Fmax2_Lstr": 1014.0,
		"Fib_Lstr1_Fmax": 1452.0,
		"Fib_Lstr1_Lstr": 2314.0,
		"Fib_Fmax_Sum_um": 18728.0,
		"Fib_Stretched_Sum_um": 22648.0,
		"woF_weighted_sum": 3926.0,
		"All_weighted_sum": 6332.0,
		"Met_weighted_sum": 327.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127007,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 64.0,
		"nm_sum": 1236.0,
		"sum_fibers": 43.0,
		"fibers_sum": 43.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127008,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127008",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.33,
		"Date_of_arrival": "2021-08-08T15:00:00",
		"Date_of_Extraction": "2021-08-08T15:00:00",
		"Date_of_Analysis": "2021-08-08T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.415772,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8186.0,
		"woF_15_25": 3956.0,
		"woF_25_50": 2115.0,
		"woF_50_100": 750.0,
		"woF_100_150": 187.0,
		"woF_150_200": 42.0,
		"woF_200_400": 31.0,
		"woF_400_600": 6.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 229.0,
		"woF_300_400": 37.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8186.0,
		"All_15_25": 3956.0,
		"All_25_50": 2115.0,
		"All_50_100": 750.0,
		"All_100_150": 188.0,
		"All_150_200": 42.0,
		"All_200_400": 50.0,
		"All_400_600": 14.0,
		"All_600_1000": 7.0,
		"All_gt_1000": 5.0,
		"All_200_300": 230.0,
		"All_300_400": 64.0,
		"All_400_500": 5.0,
		"All_500_600": null,
		"All_600_700": 4.0,
		"All_700_800": 0.0,
		"All_800_900": 1.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 13.0,
		"Met_15_25": 34.0,
		"Met_25_50": 39.0,
		"Met_50_100": 21.0,
		"Met_100_150": 15.0,
		"Met_150_200": 7.0,
		"Met_200_400": 8.0,
		"Met_400_600": 3.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 22.0,
		"Met_300_400": 11.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 985.0,
		"woFNM_1W": 160.0,
		"woFNM_2L": 609.0,
		"woFNM_2W": 258.0,
		"woFNM_3L": 549.0,
		"woFNM_3W": 97.0,
		"woFNM_4L": 426.0,
		"woFNM_4W": 211.0,
		"woFNM_5L": 402.0,
		"woFNM_5W": 75.0,
		"Met_1L": 457.0,
		"Met_1W": 96.0,
		"Met_2L": 442.0,
		"Met_2W": 175.0,
		"Met_3L": 401.0,
		"Met_3W": 118.0,
		"Met_4L": 366.0,
		"Met_4W": 258.0,
		"Met_5L": 344.0,
		"Met_5W": 75.0,
		"Fib_Fmax1_Fmax": 1983.0,
		"Fib_Fmax1_Lstr": 4854.0,
		"Fib_Fmax2_Fmax": 1573.0,
		"Fib_Fmax2_Lstr": 1751.0,
		"Fib_Lstr1_Fmax": 1983.0,
		"Fib_Lstr1_Lstr": 4854.0,
		"Fib_Fmax_Sum_um": 20244.0,
		"Fib_Stretched_Sum_um": 26027.0,
		"woF_weighted_sum": 3044.0,
		"All_weighted_sum": 6584.0,
		"Met_weighted_sum": 464.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127008,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 54.0,
		"nm_sum": 964.0,
		"sum_fibers": 38.0,
		"fibers_sum": 38.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127009,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127009",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.3,
		"Date_of_arrival": "2021-08-09T15:00:00",
		"Date_of_Extraction": "2021-08-09T15:00:00",
		"Date_of_Analysis": "2021-08-09T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.439025,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8967.0,
		"woF_15_25": 4490.0,
		"woF_25_50": 2470.0,
		"woF_50_100": 966.0,
		"woF_100_150": 223.0,
		"woF_150_200": 58.0,
		"woF_200_400": 38.0,
		"woF_400_600": 5.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 281.0,
		"woF_300_400": 43.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8967.0,
		"All_15_25": 4490.0,
		"All_25_50": 2470.0,
		"All_50_100": 966.0,
		"All_100_150": 223.0,
		"All_150_200": 58.0,
		"All_200_400": 51.0,
		"All_400_600": 14.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 3.0,
		"All_200_300": 281.0,
		"All_300_400": 65.0,
		"All_400_500": 3.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 6.0,
		"Met_15_25": 18.0,
		"Met_25_50": 43.0,
		"Met_50_100": 26.0,
		"Met_100_150": 7.0,
		"Met_150_200": 3.0,
		"Met_200_400": 9.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 10.0,
		"Met_300_400": 9.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 651.0,
		"woFNM_1W": 91.0,
		"woFNM_2L": 510.0,
		"woFNM_2W": 150.0,
		"woFNM_3L": 498.0,
		"woFNM_3W": 134.0,
		"woFNM_4L": 435.0,
		"woFNM_4W": 177.0,
		"woFNM_5L": 433.0,
		"woFNM_5W": 59.0,
		"Met_1L": 314.0,
		"Met_1W": 177.0,
		"Met_2L": 295.0,
		"Met_2W": 121.0,
		"Met_3L": 294.0,
		"Met_3W": 99.0,
		"Met_4L": 279.0,
		"Met_4W": 70.0,
		"Met_5L": 261.0,
		"Met_5W": 113.0,
		"Fib_Fmax1_Fmax": 1986.0,
		"Fib_Fmax1_Lstr": 2131.0,
		"Fib_Fmax2_Fmax": 1457.0,
		"Fib_Fmax2_Lstr": 1720.0,
		"Fib_Lstr1_Fmax": 1986.0,
		"Fib_Lstr1_Lstr": 2131.0,
		"Fib_Fmax_Sum_um": 15957.0,
		"Fib_Stretched_Sum_um": 19004.0,
		"woF_weighted_sum": 3452.0,
		"All_weighted_sum": 6012.0,
		"Met_weighted_sum": 225.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127009,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 45.0,
		"nm_sum": 1246.0,
		"sum_fibers": 29.0,
		"fibers_sum": 29.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127010,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127010",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.11,
		"Date_of_arrival": "2021-08-10T15:00:00",
		"Date_of_Extraction": "2021-08-10T15:00:00",
		"Date_of_Analysis": "2021-08-10T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.149672,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 1695.0,
		"woF_15_25": 958.0,
		"woF_25_50": 821.0,
		"woF_50_100": 338.0,
		"woF_100_150": 49.0,
		"woF_150_200": 14.0,
		"woF_200_400": 11.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 63.0,
		"woF_300_400": 13.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 1.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1695.0,
		"All_15_25": 958.0,
		"All_25_50": 821.0,
		"All_50_100": 338.0,
		"All_100_150": 49.0,
		"All_150_200": 14.0,
		"All_200_400": 12.0,
		"All_400_600": 2.0,
		"All_600_1000": 5.0,
		"All_gt_1000": 4.0,
		"All_200_300": 63.0,
		"All_300_400": 14.0,
		"All_400_500": 4.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 0.0,
		"All_800_900": 2.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 5.0,
		"Met_15_25": 17.0,
		"Met_25_50": 17.0,
		"Met_50_100": 6.0,
		"Met_100_150": 4.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 5.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 810.0,
		"woFNM_1W": 202.0,
		"woFNM_2L": 627.0,
		"woFNM_2W": 357.0,
		"woFNM_3L": 479.0,
		"woFNM_3W": 184.0,
		"woFNM_4L": 411.0,
		"woFNM_4W": 193.0,
		"woFNM_5L": 364.0,
		"woFNM_5W": 107.0,
		"Met_1L": 190.0,
		"Met_1W": 130.0,
		"Met_2L": 139.0,
		"Met_2W": 45.0,
		"Met_3L": 125.0,
		"Met_3W": 36.0,
		"Met_4L": 105.0,
		"Met_4W": 27.0,
		"Met_5L": 102.0,
		"Met_5W": 68.0,
		"Fib_Fmax1_Fmax": 1157.0,
		"Fib_Fmax1_Lstr": 1201.0,
		"Fib_Fmax2_Fmax": 1074.0,
		"Fib_Fmax2_Lstr": 1384.0,
		"Fib_Lstr1_Fmax": 946.0,
		"Fib_Lstr1_Lstr": 2535.0,
		"Fib_Fmax_Sum_um": 7118.0,
		"Fib_Stretched_Sum_um": 11419.0,
		"woF_weighted_sum": 1252.0,
		"All_weighted_sum": 3300.0,
		"Met_weighted_sum": 31.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127010,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 11.0,
		"nm_sum": 405.0,
		"sum_fibers": 8.0,
		"fibers_sum": 8.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127011,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127011",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.14,
		"Date_of_arrival": "2021-08-11T15:00:00",
		"Date_of_Extraction": "2021-08-11T15:00:00",
		"Date_of_Analysis": "2021-08-11T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.229362,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 1980.0,
		"woF_15_25": 1047.0,
		"woF_25_50": 983.0,
		"woF_50_100": 336.0,
		"woF_100_150": 52.0,
		"woF_150_200": 9.0,
		"woF_200_400": 16.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 61.0,
		"woF_300_400": 19.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1980.0,
		"All_15_25": 1047.0,
		"All_25_50": 983.0,
		"All_50_100": 336.0,
		"All_100_150": 52.0,
		"All_150_200": 9.0,
		"All_200_400": 17.0,
		"All_400_600": 4.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 3.0,
		"All_200_300": 61.0,
		"All_300_400": 21.0,
		"All_400_500": 3.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 2.0,
		"Met_15_25": 10.0,
		"Met_25_50": 17.0,
		"Met_50_100": 8.0,
		"Met_100_150": 4.0,
		"Met_150_200": 1.0,
		"Met_200_400": 2.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 5.0,
		"Met_300_400": 2.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 1438.0,
		"woFNM_1W": 1070.0,
		"woFNM_2L": 786.0,
		"woFNM_2W": 158.0,
		"woFNM_3L": 626.0,
		"woFNM_3W": 262.0,
		"woFNM_4L": 440.0,
		"woFNM_4W": 211.0,
		"woFNM_5L": 435.0,
		"woFNM_5W": 126.0,
		"Met_1L": 238.0,
		"Met_1W": 113.0,
		"Met_2L": 236.0,
		"Met_2W": 63.0,
		"Met_3L": 164.0,
		"Met_3W": 55.0,
		"Met_4L": 135.0,
		"Met_4W": 68.0,
		"Met_5L": 126.0,
		"Met_5W": 27.0,
		"Fib_Fmax1_Fmax": 1373.0,
		"Fib_Fmax1_Lstr": 1513.0,
		"Fib_Fmax2_Fmax": 1069.0,
		"Fib_Fmax2_Lstr": 1407.0,
		"Fib_Lstr1_Fmax": 1373.0,
		"Fib_Lstr1_Lstr": 1513.0,
		"Fib_Fmax_Sum_um": 3956.0,
		"Fib_Stretched_Sum_um": 5251.0,
		"woF_weighted_sum": 1761.0,
		"All_weighted_sum": 2785.0,
		"Met_weighted_sum": 65.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127011,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 15.0,
		"nm_sum": 404.0,
		"sum_fibers": 5.0,
		"fibers_sum": 5.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127012,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127012",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.1,
		"Date_of_arrival": "2021-08-12T15:00:00",
		"Date_of_Extraction": "2021-08-12T15:00:00",
		"Date_of_Analysis": "2021-08-12T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.218331,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 2148.0,
		"woF_15_25": 1189.0,
		"woF_25_50": 1064.0,
		"woF_50_100": 406.0,
		"woF_100_150": 74.0,
		"woF_150_200": 24.0,
		"woF_200_400": 16.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 4.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 98.0,
		"woF_300_400": 19.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 2.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2148.0,
		"All_15_25": 1189.0,
		"All_25_50": 1064.0,
		"All_50_100": 406.0,
		"All_100_150": 74.0,
		"All_150_200": 24.0,
		"All_200_400": 16.0,
		"All_400_600": 4.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 1.0,
		"All_200_300": 98.0,
		"All_300_400": 20.0,
		"All_400_500": 1.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 0.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 7.0,
		"Met_15_25": 6.0,
		"Met_25_50": 14.0,
		"Met_50_100": 11.0,
		"Met_100_150": 3.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 4.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 907.0,
		"woFNM_1W": 715.0,
		"woFNM_2L": 737.0,
		"woFNM_2W": 166.0,
		"woFNM_3L": 672.0,
		"woFNM_3W": 181.0,
		"woFNM_4L": 655.0,
		"woFNM_4W": 225.0,
		"woFNM_5L": 567.0,
		"woFNM_5W": 311.0,
		"Met_1L": 154.0,
		"Met_1W": 23.0,
		"Met_2L": 121.0,
		"Met_2W": 41.0,
		"Met_3L": 105.0,
		"Met_3W": 23.0,
		"Met_4L": 100.0,
		"Met_4W": 27.0,
		"Met_5L": 94.0,
		"Met_5W": 24.0,
		"Fib_Fmax1_Fmax": 1752.0,
		"Fib_Fmax1_Lstr": 5032.0,
		"Fib_Fmax2_Fmax": 523.0,
		"Fib_Fmax2_Lstr": 1089.0,
		"Fib_Lstr1_Fmax": 1752.0,
		"Fib_Lstr1_Lstr": 5032.0,
		"Fib_Fmax_Sum_um": 2275.0,
		"Fib_Stretched_Sum_um": 6121.0,
		"woF_weighted_sum": 1942.0,
		"All_weighted_sum": 2406.0,
		"Met_weighted_sum": 32.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127012,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 15.0,
		"nm_sum": 512.0,
		"sum_fibers": 2.0,
		"fibers_sum": 2.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127013,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127013",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.21,
		"Date_of_arrival": "2021-08-13T15:00:00",
		"Date_of_Extraction": "2021-08-13T15:00:00",
		"Date_of_Analysis": "2021-08-13T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.326817,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 2357.0,
		"woF_15_25": 1305.0,
		"woF_25_50": 1147.0,
		"woF_50_100": 469.0,
		"woF_100_150": 84.0,
		"woF_150_200": 24.0,
		"woF_200_400": 25.0,
		"woF_400_600": 4.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 2.0,
		"woF_200_300": 108.0,
		"woF_300_400": 29.0,
		"woF_400_500": 2.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 2.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2357.0,
		"All_15_25": 1305.0,
		"All_25_50": 1147.0,
		"All_50_100": 469.0,
		"All_100_150": 84.0,
		"All_150_200": 24.0,
		"All_200_400": 27.0,
		"All_400_600": 4.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 7.0,
		"All_200_300": 108.0,
		"All_300_400": 31.0,
		"All_400_500": 7.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 5.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 3.0,
		"Met_15_25": 16.0,
		"Met_25_50": 7.0,
		"Met_50_100": 11.0,
		"Met_100_150": 2.0,
		"Met_150_200": 1.0,
		"Met_200_400": 5.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 3.0,
		"Met_300_400": 5.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 1798.0,
		"woFNM_1W": 508.0,
		"woFNM_2L": 1756.0,
		"woFNM_2W": 1034.0,
		"woFNM_3L": 798.0,
		"woFNM_3W": 454.0,
		"woFNM_4L": 660.0,
		"woFNM_4W": 263.0,
		"woFNM_5L": 573.0,
		"woFNM_5W": 337.0,
		"Met_1L": 252.0,
		"Met_1W": 45.0,
		"Met_2L": 228.0,
		"Met_2W": 26.0,
		"Met_3L": 227.0,
		"Met_3W": 45.0,
		"Met_4L": 211.0,
		"Met_4W": 121.0,
		"Met_5L": 204.0,
		"Met_5W": 36.0,
		"Fib_Fmax1_Fmax": 1305.0,
		"Fib_Fmax1_Lstr": 1487.0,
		"Fib_Fmax2_Fmax": 1219.0,
		"Fib_Fmax2_Lstr": 1365.0,
		"Fib_Lstr1_Fmax": 1305.0,
		"Fib_Lstr1_Lstr": 1487.0,
		"Fib_Fmax_Sum_um": 8132.0,
		"Fib_Stretched_Sum_um": 9984.0,
		"woF_weighted_sum": 2765.0,
		"All_weighted_sum": 5085.0,
		"Met_weighted_sum": 108.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127013,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 19.0,
		"nm_sum": 591.0,
		"sum_fibers": 9.0,
		"fibers_sum": 9.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127014,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127014",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.19,
		"Date_of_arrival": "2021-08-14T15:00:00",
		"Date_of_Extraction": "2021-08-14T15:00:00",
		"Date_of_Analysis": "2021-08-14T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.428147,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 2909.0,
		"woF_15_25": 1616.0,
		"woF_25_50": 1535.0,
		"woF_50_100": 671.0,
		"woF_100_150": 141.0,
		"woF_150_200": 39.0,
		"woF_200_400": 40.0,
		"woF_400_600": 6.0,
		"woF_600_1000": 5.0,
		"woF_gt_1000": 3.0,
		"woF_200_300": 180.0,
		"woF_300_400": 46.0,
		"woF_400_500": 3.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 2.0,
		"woF_900_1000": 2.0,
		"woF_1000_1500": 2.0,
		"woF_1500_2000": 1.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2909.0,
		"All_15_25": 1616.0,
		"All_25_50": 1535.0,
		"All_50_100": 671.0,
		"All_100_150": 141.0,
		"All_150_200": 40.0,
		"All_200_400": 44.0,
		"All_400_600": 9.0,
		"All_600_1000": 6.0,
		"All_gt_1000": 6.0,
		"All_200_300": 181.0,
		"All_300_400": 53.0,
		"All_400_500": 6.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 2.0,
		"All_900_1000": 3.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 3.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 5.0,
		"Met_15_25": 9.0,
		"Met_25_50": 11.0,
		"Met_50_100": 14.0,
		"Met_100_150": 1.0,
		"Met_150_200": 2.0,
		"Met_200_400": 3.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 3.0,
		"Met_300_400": 3.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 1616.0,
		"woFNM_1W": 574.0,
		"woFNM_2L": 1359.0,
		"woFNM_2W": 701.0,
		"woFNM_3L": 1281.0,
		"woFNM_3W": 330.0,
		"woFNM_4L": 994.0,
		"woFNM_4W": 203.0,
		"woFNM_5L": 972.0,
		"woFNM_5W": 182.0,
		"Met_1L": 348.0,
		"Met_1W": 166.0,
		"Met_2L": 261.0,
		"Met_2W": 93.0,
		"Met_3L": 203.0,
		"Met_3W": 135.0,
		"Met_4L": 172.0,
		"Met_4W": 26.0,
		"Met_5L": 165.0,
		"Met_5W": 54.0,
		"Fib_Fmax1_Fmax": 1836.0,
		"Fib_Fmax1_Lstr": 2015.0,
		"Fib_Fmax2_Fmax": 1534.0,
		"Fib_Fmax2_Lstr": 1768.0,
		"Fib_Lstr1_Fmax": 1836.0,
		"Fib_Lstr1_Lstr": 2015.0,
		"Fib_Fmax_Sum_um": 8401.0,
		"Fib_Stretched_Sum_um": 10164.0,
		"woF_weighted_sum": 4530.0,
		"All_weighted_sum": 6139.0,
		"Met_weighted_sum": 84.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127014,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 20.0,
		"nm_sum": 885.0,
		"sum_fibers": 12.0,
		"fibers_sum": 12.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127015,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127015",
		"Parts_on_Filter": 5.0,
		"Component_Surface_Area_cm2": 167.0,
		"Weight_mg": 0.13,
		"Date_of_arrival": "2021-08-15T15:00:00",
		"Date_of_Extraction": "2021-08-15T15:00:00",
		"Date_of_Analysis": "2021-08-15T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.286913,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 2308.0,
		"woF_15_25": 1214.0,
		"woF_25_50": 1116.0,
		"woF_50_100": 458.0,
		"woF_100_150": 96.0,
		"woF_150_200": 35.0,
		"woF_200_400": 24.0,
		"woF_400_600": 7.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 131.0,
		"woF_300_400": 31.0,
		"woF_400_500": 1.0,
		"woF_500_600": null,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 1.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 2308.0,
		"All_15_25": 1214.0,
		"All_25_50": 1116.0,
		"All_50_100": 458.0,
		"All_100_150": 96.0,
		"All_150_200": 37.0,
		"All_200_400": 24.0,
		"All_400_600": 9.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 7.0,
		"All_200_300": 133.0,
		"All_300_400": 33.0,
		"All_400_500": 7.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 3.0,
		"Met_15_25": 13.0,
		"Met_25_50": 14.0,
		"Met_50_100": 9.0,
		"Met_100_150": 4.0,
		"Met_150_200": 1.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 5.0,
		"Met_300_400": 1.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 2270.0,
		"woFNM_1W": 601.0,
		"woFNM_2L": 962.0,
		"woFNM_2W": 146.0,
		"woFNM_3L": 607.0,
		"woFNM_3W": 378.0,
		"woFNM_4L": 523.0,
		"woFNM_4W": 229.0,
		"woFNM_5L": 514.0,
		"woFNM_5W": 257.0,
		"Met_1L": 336.0,
		"Met_1W": 36.0,
		"Met_2L": 172.0,
		"Met_2W": 30.0,
		"Met_3L": 128.0,
		"Met_3W": 77.0,
		"Met_4L": 119.0,
		"Met_4W": 68.0,
		"Met_5L": 104.0,
		"Met_5W": 50.0,
		"Fib_Fmax1_Fmax": 2228.0,
		"Fib_Fmax1_Lstr": 5125.0,
		"Fib_Fmax2_Fmax": 1850.0,
		"Fib_Fmax2_Lstr": 1934.0,
		"Fib_Lstr1_Fmax": 2228.0,
		"Fib_Lstr1_Lstr": 5125.0,
		"Fib_Fmax_Sum_um": 10838.0,
		"Fib_Stretched_Sum_um": 15092.0,
		"woF_weighted_sum": 2677.0,
		"All_weighted_sum": 5223.0,
		"Met_weighted_sum": 50.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127015,
		"Passed": "0",
		"zeichnr": "Stecker",
		"met_sum": 15.0,
		"nm_sum": 607.0,
		"sum_fibers": 9.0,
		"fibers_sum": 9.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127016,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127016",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 178.0,
		"Weight_mg": 0.08,
		"Date_of_arrival": "2021-08-16T15:00:00",
		"Date_of_Extraction": "2021-08-16T15:00:00",
		"Date_of_Analysis": "2021-08-16T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.09898,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 1623.0,
		"woF_15_25": 817.0,
		"woF_25_50": 672.0,
		"woF_50_100": 234.0,
		"woF_100_150": 31.0,
		"woF_150_200": 8.0,
		"woF_200_400": 9.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 39.0,
		"woF_300_400": 12.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1623.0,
		"All_15_25": 817.0,
		"All_25_50": 672.0,
		"All_50_100": 234.0,
		"All_100_150": 31.0,
		"All_150_200": 9.0,
		"All_200_400": 12.0,
		"All_400_600": 3.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 2.0,
		"All_200_300": 40.0,
		"All_300_400": 15.0,
		"All_400_500": 2.0,
		"All_500_600": null,
		"All_600_700": 1.0,
		"All_700_800": 0.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 9.0,
		"Met_15_25": 27.0,
		"Met_25_50": 47.0,
		"Met_50_100": 12.0,
		"Met_100_150": 3.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 4.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 575.0,
		"woFNM_1W": 142.0,
		"woFNM_2L": 473.0,
		"woFNM_2W": 188.0,
		"woFNM_3L": 427.0,
		"woFNM_3W": 85.0,
		"woFNM_4L": 371.0,
		"woFNM_4W": 129.0,
		"woFNM_5L": 354.0,
		"woFNM_5W": 167.0,
		"Met_1L": 186.0,
		"Met_1W": 41.0,
		"Met_2L": 136.0,
		"Met_2W": 59.0,
		"Met_3L": 125.0,
		"Met_3W": 67.0,
		"Met_4L": 105.0,
		"Met_4W": 66.0,
		"Met_5L": 90.0,
		"Met_5W": 36.0,
		"Fib_Fmax1_Fmax": 1076.0,
		"Fib_Fmax1_Lstr": 1137.0,
		"Fib_Fmax2_Fmax": 1026.0,
		"Fib_Fmax2_Lstr": 1043.0,
		"Fib_Lstr1_Fmax": 1076.0,
		"Fib_Lstr1_Lstr": 1137.0,
		"Fib_Fmax_Sum_um": 5629.0,
		"Fib_Stretched_Sum_um": 6052.0,
		"woF_weighted_sum": 766.0,
		"All_weighted_sum": 2055.0,
		"Met_weighted_sum": 33.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127016,
		"Passed": "1",
		"zeichnr": "Stecker",
		"met_sum": 16.0,
		"nm_sum": 269.0,
		"sum_fibers": 9.0,
		"fibers_sum": 9.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127017,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127017",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 178.0,
		"Weight_mg": 0.07,
		"Date_of_arrival": "2021-08-17T15:00:00",
		"Date_of_Extraction": "2021-08-17T15:00:00",
		"Date_of_Analysis": "2021-08-17T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.091622,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 1484.0,
		"woF_15_25": 689.0,
		"woF_25_50": 569.0,
		"woF_50_100": 190.0,
		"woF_100_150": 23.0,
		"woF_150_200": 10.0,
		"woF_200_400": 11.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 33.0,
		"woF_300_400": 13.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1484.0,
		"All_15_25": 689.0,
		"All_25_50": 569.0,
		"All_50_100": 190.0,
		"All_100_150": 23.0,
		"All_150_200": 10.0,
		"All_200_400": 14.0,
		"All_400_600": 5.0,
		"All_600_1000": 2.0,
		"All_gt_1000": 1.0,
		"All_200_300": 33.0,
		"All_300_400": 19.0,
		"All_400_500": 1.0,
		"All_500_600": null,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 1.0,
		"Met_15_25": 9.0,
		"Met_25_50": 20.0,
		"Met_50_100": 8.0,
		"Met_100_150": 0.0,
		"Met_150_200": 1.0,
		"Met_200_400": 0.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 1.0,
		"Met_300_400": 0.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 467.0,
		"woFNM_1W": 293.0,
		"woFNM_2L": 411.0,
		"woFNM_2W": 112.0,
		"woFNM_3L": 337.0,
		"woFNM_3W": 126.0,
		"woFNM_4L": 318.0,
		"woFNM_4W": 256.0,
		"woFNM_5L": 301.0,
		"woFNM_5W": 189.0,
		"Met_1L": 196.0,
		"Met_1W": 18.0,
		"Met_2L": 86.0,
		"Met_2W": 65.0,
		"Met_3L": 77.0,
		"Met_3W": 60.0,
		"Met_4L": 62.0,
		"Met_4W": 16.0,
		"Met_5L": 59.0,
		"Met_5W": 31.0,
		"Fib_Fmax1_Fmax": 1447.0,
		"Fib_Fmax1_Lstr": 1659.0,
		"Fib_Fmax2_Fmax": 882.0,
		"Fib_Fmax2_Lstr": 1002.0,
		"Fib_Lstr1_Fmax": 1447.0,
		"Fib_Lstr1_Lstr": 1659.0,
		"Fib_Fmax_Sum_um": 5330.0,
		"Fib_Stretched_Sum_um": 6154.0,
		"woF_weighted_sum": 676.0,
		"All_weighted_sum": 1604.0,
		"Met_weighted_sum": 17.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127017,
		"Passed": "1",
		"zeichnr": "Stecker",
		"met_sum": 9.0,
		"nm_sum": 227.0,
		"sum_fibers": 9.0,
		"fibers_sum": 9.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"new": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Stecker",
		"betaufnr": 127018,
		"kdnr": 12346,
		"artnr": "5123436",
		"Analysis_No": "127018",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 178.0,
		"Weight_mg": 0.03,
		"Date_of_arrival": "2021-08-18T15:00:00",
		"Date_of_Extraction": "2021-08-18T15:00:00",
		"Date_of_Analysis": "2021-08-18T15:00:00",
		"Component": "Stecker",
		"Component_No": "XYZ",
		"Testing_Specification": "5123436",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.087353,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 1245.0,
		"woF_15_25": 601.0,
		"woF_25_50": 502.0,
		"woF_50_100": 156.0,
		"woF_100_150": 22.0,
		"woF_150_200": 6.0,
		"woF_200_400": 7.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 28.0,
		"woF_300_400": 9.0,
		"woF_400_500": 0.0,
		"woF_500_600": null,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 1245.0,
		"All_15_25": 601.0,
		"All_25_50": 502.0,
		"All_50_100": 156.0,
		"All_100_150": 22.0,
		"All_150_200": 7.0,
		"All_200_400": 10.0,
		"All_400_600": 3.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 3.0,
		"All_200_300": 29.0,
		"All_300_400": 13.0,
		"All_400_500": 3.0,
		"All_500_600": null,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 5.0,
		"Met_15_25": 17.0,
		"Met_25_50": 25.0,
		"Met_50_100": 11.0,
		"Met_100_150": 1.0,
		"Met_150_200": 1.0,
		"Met_200_400": 1.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 2.0,
		"Met_300_400": 1.0,
		"Met_400_500": 0.0,
		"Met_500_600": null,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 595.0,
		"woFNM_1W": 210.0,
		"woFNM_2L": 507.0,
		"woFNM_2W": 108.0,
		"woFNM_3L": 327.0,
		"woFNM_3W": 209.0,
		"woFNM_4L": 306.0,
		"woFNM_4W": 147.0,
		"woFNM_5L": 287.0,
		"woFNM_5W": 117.0,
		"Met_1L": 264.0,
		"Met_1W": 70.0,
		"Met_2L": 179.0,
		"Met_2W": 118.0,
		"Met_3L": 105.0,
		"Met_3W": 76.0,
		"Met_4L": 95.0,
		"Met_4W": 81.0,
		"Met_5L": 92.0,
		"Met_5W": 63.0,
		"Fib_Fmax1_Fmax": 2555.0,
		"Fib_Fmax1_Lstr": 3159.0,
		"Fib_Fmax2_Fmax": 2348.0,
		"Fib_Fmax2_Lstr": 3970.0,
		"Fib_Lstr1_Fmax": 2348.0,
		"Fib_Lstr1_Lstr": 3970.0,
		"Fib_Fmax_Sum_um": 10472.0,
		"Fib_Stretched_Sum_um": 15987.0,
		"woF_weighted_sum": 538.0,
		"All_weighted_sum": 2435.0,
		"Met_weighted_sum": 40.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 127018,
		"Passed": "1",
		"zeichnr": "Stecker",
		"met_sum": 14.0,
		"nm_sum": 179.0,
		"sum_fibers": 11.0,
		"fibers_sum": 11.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"new": true,
		"zeichindex": "1234"
	}
]
